module.exports = __webpack_public_path__ + "static/img/12.6391dc4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/sp/12.png
// module id = pyq8
// module chunks = 0